import { useEffect, useState } from "react";
import { Wallet } from "lucide-react";
import { PageHeader, StatusBadge, EmptyState, Loading, Pager, Card } from "../../components/common";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../../components/ui/table";
import { api } from "../../lib/api";
import { pkr, fmtDate, COMMISSION_STATUS } from "../../lib/format";

const TABS = [["", "All"], ["pending,eligible", "Pending"], ["approved", "Approved"], ["paid", "Paid"], ["rejected,reversed", "Rejected / Reversed"]];

export default function MyCommissions() {
  const [status, setStatus] = useState("");
  const [page, setPage] = useState(1);
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/commissions/mine", { params: { status, page } }).then((r) => setData(r.data)); }, [status, page]);
  return (
    <div>
      <PageHeader title="My Commissions" subtitle="Pending → Eligible for review → Approved / Payable → Paid" />
      <div className="mb-4 flex gap-2 overflow-x-auto">{TABS.map(([v, l]) => (
        <button key={l} onClick={() => { setStatus(v); setPage(1); }} data-testid={`commission-tab-${l.toLowerCase().replace(/[^a-z]+/g, "-")}`}
          className={`whitespace-nowrap rounded-full border px-4 py-2 text-sm font-medium ${status === v ? "border-[#0B192C] bg-[#0B192C] text-white" : "bg-white text-slate-700"}`}>{l}</button>
      ))}</div>
      {!data ? <Loading /> : data.items.length === 0 ? <EmptyState icon={Wallet} title="No commissions" message="Commissions are created when you book orders." /> : (
        <Card className="overflow-x-auto">
          <Table>
            <TableHeader><TableRow><TableHead>Order</TableHead><TableHead>Deal</TableHead><TableHead className="text-right">Order total</TableHead><TableHead className="text-right">Commission</TableHead><TableHead>Status</TableHead><TableHead>Updated</TableHead></TableRow></TableHeader>
            <TableBody>
              {data.items.map((c) => (
                <TableRow key={c.id} data-testid={`commission-row-${c.order_no}`}>
                  <TableCell className="whitespace-nowrap font-mono font-semibold">{c.order_no}</TableCell>
                  <TableCell className="min-w-[160px]">{c.deal_name}{c.reason && <p className="text-xs text-red-600">{c.reason}</p>}</TableCell>
                  <TableCell className="text-right font-mono">{pkr(c.order_total)}</TableCell>
                  <TableCell className="text-right font-mono font-bold">{pkr(c.amount)}</TableCell>
                  <TableCell><StatusBadge map={COMMISSION_STATUS} value={c.status} />{c.recovery_due && <p className="mt-1 text-xs text-red-600">Recovery due</p>}</TableCell>
                  <TableCell className="whitespace-nowrap text-sm text-slate-500">{fmtDate(c.updated_at)}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
          <div className="px-4 pb-4"><Pager page={data.page} pages={data.pages} total={data.total} onPage={setPage} /></div>
        </Card>
      )}
    </div>
  );
}
